<template>
  <a-modal v-model="visible" :title="title" class="prompt-cell" @ok="ok" @cancel="cancel">
    <div>
      <a-input v-model="value" placeholder="" />
    </div>
  </a-modal>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    propmtVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      value: this.text,
      visible: false
    }
  },
  watch: {
    propmtVisible() {
      this.visible = this.propmtVisible
    }
  },
  methods: {
    ok() {
      this.$emit('ok', this.value)
      this.value = ''
    },
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>
